import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'filter-icon',
  templateUrl: './filter-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FilterIconComponent {}
